exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container-form[data-v-4bb632be]{background:#6198c8}.container-form-inner[data-v-4bb632be]{background:#f2f2f2;border-radius:30px}.container-form-inner .v-card__title[data-v-4bb632be],.v-expansion-panel__header .v-card__title[data-v-4bb632be]{color:#004990;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;background:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4bb632be","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/pages/admissions/manage/score.vue
// module id = WwjO
// module chunks = 2